document.addEventListener('DOMContentLoaded', function () {
  function fixRebuyAccessibility() {
    /* ----------------------------------
     1. Disable focus in hidden slides
    ---------------------------------- */
    document.querySelectorAll('.rebuy-product-block[aria-hidden="true"]').forEach((block) => {
      const focusable = block.querySelectorAll('a, button, input, select, textarea, [tabindex]');
      focusable.forEach((el) => el.setAttribute('tabindex', '-1'));
    });

    /* ----------------------------------
     2. Restore focus in visible slides
    ---------------------------------- */
    document.querySelectorAll('.rebuy-product-block:not([aria-hidden="true"])').forEach((block) => {
      const focusable = block.querySelectorAll('[tabindex="-1"]');
      focusable.forEach((el) => el.removeAttribute('tabindex'));
    });

    /* ----------------------------------
     3. Remove heading semantics (fix hierarchy completely)
    ---------------------------------- */
    document.querySelectorAll('.rebuy-product-title').forEach((el) => {
      if (el.tagName.toLowerCase() === 'div') return;

      const newEl = document.createElement('div');
      newEl.innerHTML = el.innerHTML;
      newEl.className = el.className;

      el.replaceWith(newEl);
    });

    document.querySelectorAll('.super-title').forEach((el) => {
      if (el.tagName.toLowerCase() === 'div') return;

      const newEl = document.createElement('div');
      newEl.innerHTML = el.innerHTML;
      newEl.className = el.className;

      el.replaceWith(newEl);
    });

    /* ----------------------------------
     4. Remove empty roles
    ---------------------------------- */
    document.querySelectorAll('[role=""]').forEach((el) => {
      el.removeAttribute('role');
    });
  }

  function fixEmptyLinks() {
    document.querySelectorAll('a[href]:not([aria-label]):not([aria-labelledby])').forEach(function (link) {
      if ((link.textContent || '').trim()) return;
      var hasNameFromImg = Array.prototype.some.call(link.querySelectorAll('img'), function (img) {
        var alt = img.getAttribute('alt');
        return alt && alt.trim() && img.getAttribute('role') !== 'presentation' && img.getAttribute('role') !== 'none';
      });
      if (hasNameFromImg) return;
      var href = link.getAttribute('href') || '';
      var label = 'Link';
      if (href.indexOf('instagram.com') !== -1) label = 'View on Instagram';
      else if (href.indexOf('madebymary.com') !== -1 || href === '/') label = 'Made By Mary';
      link.setAttribute('aria-label', label);
    });
  }

  function fixDuplicateLinks() {
    // Fix duplicate "View" links inside FourSixty product modals.
    // Each tagged post opens a panel with one "View" link per product;
    // when multiple products are shown, all links read "View" → duplicate.
    // Resolve by appending the nearest product name from the sibling card.
    var viewLinks = Array.prototype.filter.call(
      document.querySelectorAll('a[href]:not([aria-label]):not([aria-labelledby])'),
      function (link) {
        return (link.textContent || '').trim() === 'View';
      }
    );
    if (viewLinks.length > 1) {
      viewLinks.forEach(function (link) {
        var card = link.closest('.fs-product, .fs-text-product, [class*="fs-product"]');
        var nameEl = card && card.querySelector('.fs-product-name, .fs-text-product-name, [class*="product-name"]');
        var name = nameEl ? (nameEl.textContent || '').trim() : '';
        link.setAttribute('aria-label', name ? 'View ' + name : 'View product');
      });
    }

    // Fix duplicate "List of Ingredients" links — add nearest product name as context
    var ingredientLinks = Array.prototype.filter.call(
      document.querySelectorAll('a[href]:not([aria-label]):not([aria-labelledby])'),
      function (link) {
        return (link.textContent || '').trim() === 'List of Ingredients';
      }
    );
    if (ingredientLinks.length > 1) {
      ingredientLinks.forEach(function (link) {
        var container = link.closest('[data-product-id], .rebuy-product-block');
        if (!container) return;
        var titleEl = container.querySelector('.rebuy-product-title, .product__title, h1, h2, h3');
        if (!titleEl) return;
        var name = (titleEl.textContent || '').trim();
        if (name) link.setAttribute('aria-label', 'List of Ingredients for ' + name);
      });
    }
  }

  function fixAriaLabelledByBlank() {
    // When aria-labelledby references an element with no text (e.g. a logo-image tab),
    // the region has no accessible name. Add a visually-hidden label to the target element.
    document.querySelectorAll('[aria-labelledby]').forEach(function (el) {
      var id = el.getAttribute('aria-labelledby');
      var target = document.getElementById(id);
      if (!target) return;
      if ((target.textContent || '').trim()) return; // already has text, nothing to do

      // 1. Try the alt text of an image inside the target
      var img = target.querySelector('img');
      var label = img ? (img.getAttribute('alt') || '').trim() : '';

      // 2. Try the target's own title attribute
      if (!label) label = (target.getAttribute('title') || '').trim();

      // 3. Parse a name from the ID (e.g. 'asi-tabpublication_forbes' → 'Forbes')
      if (!label) {
        label = id
          .replace(/^[\w-]*publication[_-]?/i, '')
          .replace(/[-_]+/g, ' ')
          .trim()
          .replace(/\b\w/g, function (c) { return c.toUpperCase(); });
      }

      if (!label) return;

      var span = document.createElement('span');
      span.className = 'visually-hidden';
      span.textContent = label;
      target.appendChild(span);
    });
  }

  function fixEmptyHeadings() {
    document.querySelectorAll('h1,h2,h3,h4,h5,h6,[role="heading"]').forEach(function (el) {
      var text = (el.textContent || '').replace(/\u00a0/g, ' ').trim();
      if (text) return;
      var hasAltImg = Array.prototype.some.call(el.querySelectorAll('img'), function (img) {
        return (img.getAttribute('alt') || '').trim();
      });
      if (hasAltImg) return;

      var div = document.createElement('div');
      div.className = el.className;
      Array.prototype.forEach.call(el.attributes, function (attr) {
        if (attr.name === 'role' || attr.name.indexOf('aria-level') === 0) return;
        div.setAttribute(attr.name, attr.value);
      });
      div.setAttribute('aria-hidden', 'true');
      el.replaceWith(div);
    });
  }

  function fixIframeTitles() {
    document.querySelectorAll('iframe:not([title]), iframe[title=""]').forEach(function (frame) {
      var src = frame.getAttribute('src') || frame.getAttribute('data-src') || '';
      var title = 'Embedded content';
      if (src.indexOf('youtube') !== -1 || src.indexOf('youtu.be') !== -1) title = 'YouTube video';
      else if (src.indexOf('vimeo.com') !== -1) title = 'Vimeo video';
      else if (src.indexOf('faire.com') !== -1) title = 'Faire wholesale ordering widget';
      frame.setAttribute('title', title);
    });
  }

  // Initial run
  fixRebuyAccessibility();
  fixIframeTitles();
  fixEmptyLinks();
  fixDuplicateLinks();
  fixAriaLabelledByBlank();
  fixEmptyHeadings();

  // Re-run when third-party apps (Rebuy, FourSixty, Okendo, etc.) inject content
  const observer = new MutationObserver(() => {
    fixRebuyAccessibility();
    fixEmptyLinks();
    fixDuplicateLinks();
    fixAriaLabelledByBlank();
    fixEmptyHeadings();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
